import $ from 'jquery';
import Popper from 'popper.js';

window.Popper = Popper;

import 'bootstrap';

export { $, Popper };
